module.exports = __webpack_public_path__ + "img/1f620.922f790.svg";